import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ScrollToTop from 'src/components/layout/ScrollToTop';
import Contents from 'src/components/ui-component/mein-bereich/Contents';
import SideBars from 'src/components/ui-component/mein-bereich/Sidebars';
import { PAGES_URLS } from 'src/lib/constants/routes';
import { SidebarType } from 'src/lib/types/types';
import OrganisationBankDaten from './content/bankdaten/BankDaten';
import LoginData from './content/login-data/LoginData';
import NutzerVerwaltung from './content/nutzerverwaltung/NutzerVerwaltung';
import OrganisationsProfil from './content/organisationsprofil/OrganisationsProfil';
import PersonalData from './content/personal-data/PersonalData';

function MeinProfil() {
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const [activeSideBarButton, setActiveSideBarButton] = useState<number>(0);

	const sidebars: SidebarType = [
		{ key: 'profil', label: 'Mein Profil', element: <PersonalData /> },
		{ key: 'zugangsdaten', label: 'Zugangsdaten / Passwort', element: <LoginData /> },
		{ key: 'organisation', label: 'Organisationsprofil', element: <OrganisationsProfil /> },
		{ key: 'bankverbindung', label: 'Bankverbindung', element: <OrganisationBankDaten /> },
		{ key: 'personenverwaltung', label: 'Personenverwaltung', element: <NutzerVerwaltung /> },
	];

	useEffect(() => {
		const activeTab = searchParams.get('activeSideBarButton');
		if (activeTab) {
			const index = sidebars.findIndex((sidebar) => sidebar.key === activeTab);
			if (index !== -1) {
				setActiveSideBarButton(index);
			} else {
				setActiveSideBarButton(0);
			}
		} else {
			setActiveSideBarButton(0);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchParams]);

	const toggleSideBarButton = (_event: React.SyntheticEvent, newSideBarButton: number) => {
		setActiveSideBarButton(newSideBarButton);
		const selectedSidebar = sidebars[newSideBarButton];
		if (selectedSidebar?.key) {
			setSearchParams({ activeSideBarButton: selectedSidebar.key });
		}
	};

	return (
		<>
			<ScrollToTop />
			<Box
				sx={{
					display: 'flex',
					width: '100%',
					padding: '0 1.875rem',
					margin: '2rem auto 0',
					boxSizing: 'border-box',
				}}
			>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: { xs: 'strech', xl: 'baseline' },
						width: '100%',
						minHeight: '100px',
						flexDirection: { xs: 'column', xl: 'row' },
					}}
				>
					<Box
						sx={{
							textAlign: 'left',
							marginBottom: '2rem',
							display: 'flex',
							flex: 1,
							flexDirection: 'column',
							alignItems: { xs: 'center', xl: 'flex-end' },
						}}
					>
						<Button
							variant='outlined'
							startIcon={<ArrowBackIcon />}
							onClick={() => {
								navigate(PAGES_URLS.MeinBereich);
							}}
							sx={{ m: '1rem 2rem 1rem 0', minWidth: '16.4rem' }}
						>
							Zurück zu Mein Bereich
						</Button>
						<SideBars sidebars={sidebars} activeSideBarButton={activeSideBarButton} toggleSideBarButton={toggleSideBarButton} />
					</Box>
					<Box sx={{ flex: '1 1 71.25rem', display: 'flex', justifyContent: 'flex-start' }}>
						<Contents sidebars={sidebars} activeSideBarButton={activeSideBarButton} />
					</Box>
				</Box>
			</Box>
		</>
	);
}

export default MeinProfil;
